export default "__VITE_ASSET__CnLQEihq__"